import Vue from 'vue'
import VueI18n from 'vue-i18n'
import langs from './langs.js'

var language = langs.language()

const translations = {
    en: {
        planets: {
            constellation: 'Constellation',
            sun: 'sun',
            moon: 'moon',
            moon_other: 'moon',
            mercury: 'mercury',
            venus: 'venus',
            earth: 'earth',
            mars: 'mars',
            jupiter: 'jupiter',
            saturn: 'saturn',
            uranus: 'uranus',
            neptune: 'neptune',
            pluto: 'pluto',
            planet: 'planet'
        },
        galaxy_type: {
            elliptical: 'Elliptical Galaxy',
            bar_spiral: 'Barred Spiral Galaxy',
            int_spiral: 'Intermediate Spiral Galaxy',
            spiral: 'Spiral Galaxy',
            lenticular: 'Lenticular Galaxy',
            irregular: 'Irregular Galaxy',
            dwf_spheroidal: 'Dwarf Spheroidal Galaxy',
            dwf_elliptical: 'Dwarf Elliptical Galaxy'
        },
        ui: {
            app: {
                ephemeris: 'Ephemeris',
                planets_tonight: 'Planets Tonight',
                settings: 'Settings',
                lang_settings: 'Change language',
                view_settings: 'View Settings',
                about: 'About',
                data_credits: 'Data Credits',
                privacy: 'Privacy',
                registraunaestrella: 'Register a star',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: 'Planetarium',
                online: 'Online'
            },
            bottom_bar: {
                constellations: 'Constellations',
                constellations_art: 'Constellations Art',
                atmosphere: 'Atmosphere',
                landscape: 'Landscape',
                az_grid: 'Azimuthal Grid',
                eq_grid: 'Equatorial Grid',
                dso: 'Deep Sky Objects',
                night_mode: 'Night Mode',
                fullscreen: 'Fullscreen'
            },
            common: {
                close: 'Close',
                near: 'Near ',
                unknown: 'Unknown'
            },
            date_time_picker: {
                back_realtime: 'Back to realtime',
                pause_unpause: 'Pause/unpause time',
                daytime: 'Daytime',
                dark_night: 'Dark night',
                moonlight: 'Moonlight',
                sunrise: 'Sunrise',
                sunset: 'Sunset'
            },
            gui_loader: {
                titlep1: 'Loading Planetarium ',
                titlep2: 'Online',
                titlep3: ' | Register a star',
                error_cannot_load_wasm: 'Online Planetarium could not be displayed',
                error_wasm_is_needed: ' Your browser cannot load Web Assembly!',
                error_wasm: 'In order for Planetarium Online to display the star map, Web Assembly is required. Try again with different browser!'
            },
            lang_settings_dialog: {
                lang_settings: 'Change language',
                select_lang: 'Select language'
            },
            location_dialog: {
                use_autolocation: 'Use Autolocation'
            },
            location_mgr: {
                my_locations: 'My Locations',
                use_this_location: ' Use this location',
                unknown_address: 'Unknown Address',
                drag_to_adjust: 'Drag to adjust'
            },
            planets_visibility: {
                planets_visibility: 'Planets Visibility',
                night_from: 'Night from',
                to: 'to',
                rise: 'Rise',
                set: 'Set'
            },
            skysource_search: {
                search: 'Search...'
            },
            toolbar: {
                observe: 'Observe'
            },
            selected_object_info: {
                known_as: 'Also known as',
                read_more_on: ' read more on ',
                magnitude: 'Magnitude',
                distance: 'Distance',
                radius: 'Radius',
                spectral_type: 'Spectral type',
                size: 'Size',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'Phase',
                not_visible: 'Not visible tonight',
                visible: 'Always visible tonight',
                visibility: 'Visibility',
                rise: 'Rise',
                set: 'Set',
                unknown: 'Unknown',
                light_years: 'light years',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: 'View Settings',
                milky_way: 'Milky Way',
                dss: 'DSS',
                simulate_refraction: 'Simulate refraction',
                meridian_line: 'Meridian Line',
                ecliptic_line: 'Ecliptic Line',
                orange_night_mode: 'Orange night mode (default is red)'
            }
        }
    },
    zh: {
        planets: {
            constellation: '星座',
            sun: '太阳',
            moon: '月球',
            moon_other: '衛星',
            mercury: '水星',
            venus: '金星',
            earth: '地球',
            mars: '火星',
            jupiter: '木星',
            saturn: '土星',
            uranus: '乌拉诺斯',
            neptune: '海王星',
            pluto: '冥王星',
            planet: '星球'
        },
        galaxy_type: {
            elliptical: '椭圆星系',
            bar_spiral: '棒旋星系',
            int_spiral: '中間螺旋星系',
            spiral: '螺旋星系',
            lenticular: '透鏡狀星系',
            irregular: '不规则星系',
            dwf_spheroidal: '矮橢球星系',
            dwf_elliptical: '矮橢圓星系'
        },
        ui: {
            app: {
                ephemeris: '星历表',
                planets_tonight: '今晚的行星',
                settings: '设置',
                lang_settings: '改变语言',
                view_settings: '查看设置',
                about: '关于',
                data_credits: '数据积分',
                privacy: '隐私',
                registraunaestrella: '注册一个明星',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: '天文馆',
                online: '在线'
            },
            bottom_bar: {
                constellations: '星座',
                constellations_art: '星座艺术',
                atmosphere: '气氛',
                landscape: '景观',
                az_grid: '方位角网格',
                eq_grid: '赤道网格',
                dso: '深空天体',
                night_mode: '夜间模式',
                fullscreen: '全屏'
            },
            common: {
                close: '关闭',
                near: '靠近 ',
                unknown: '不详'
            },
            date_time_picker: {
                back_realtime: '回归实时性',
                pause_unpause: '暂停/不暂停时间',
                daytime: '白天',
                dark_night: '黑夜',
                moonlight: '月光',
                sunrise: '日出',
                sunset: '日落'
            },
            gui_loader: {
                titlep1: '加载天文馆 ',
                titlep2: '在线',
                titlep3: ' | 注册一个明星',
                error_cannot_load_wasm: '无法显示在线天文馆',
                error_wasm_is_needed: ' 您的浏览器无法加载 Web Assembly!',
                error_wasm: '为了让Planetarium Online显示星图，需要使用Web Assembly。请用不同的浏览器再试一次!'
            },
            lang_settings_dialog: {
                lang_settings: '改变语言',
                select_lang: '选择语言'
            },
            location_dialog: {
                use_autolocation: '使用自动定位'
            },
            location_mgr: {
                my_locations: '我的位置',
                use_this_location: ' 使用这个位置',
                unknown_address: '未知地址',
                drag_to_adjust: '拖动来调整'
            },
            planets_visibility: {
                planets_visibility: 'Planets Visibility',
                night_from: '夜间从',
                to: '晚上到',
                rise: '上升',
                set: '设置'
            },
            skysource_search: {
                search: '搜索...'
            },
            toolbar: {
                observe: '观察'
            },
            selected_object_info: {
                known_as: '也被称为',
                read_more_on: ' 阅读更多关于 ',
                magnitude: '规模',
                distance: '距离',
                radius: '半径',
                spectral_type: '光谱类型',
                size: '尺寸',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: '阶段',
                not_visible: '今晚不可见',
                visible: '今晚始终可见',
                visibility: '可见性',
                rise: '上升',
                set: '设置',
                unknown: '不详',
                light_years: '光年',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: '查看设置',
                milky_way: '银河系',
                dss: 'DSS',
                simulate_refraction: '模拟折射',
                meridian_line: '子午线',
                ecliptic_line: '黄道线',
                orange_night_mode: '橙色夜间模式（默认为红色）'
            }
        }
    },
    jp: {
        planets: {
            constellation: '星座',
            sun: '太陽',
            moon: '月',
            moon_other: '衛星',
            mercury: '水星',
            venus: '金星',
            earth: '地球',
            mars: '火星',
            jupiter: '木星',
            saturn: '土星',
            uranus: '天王星',
            neptune: '海王星',
            pluto: '冥王星',
            planet: '惑星'
        },
        galaxy_type: {
            elliptical: '楕円銀河',
            bar_spiral: '棒渦巻銀河',
            int_spiral: '中間渦巻銀河',
            spiral: '渦巻銀河',
            lenticular: 'レンズ状銀河',
            irregular: '不規則銀河',
            dwf_spheroidal: '矮小楕円体銀河',
            dwf_elliptical: '矮小楕円銀河'
        },
        ui: {
            app: {
                ephemeris: '天体暦',
                planets_tonight: '今夜の惑星',
                settings: '設定',
                lang_settings: '言語の変更',
                view_settings: '設定を見る',
                about: 'についてです',
                data_credits: 'データクレジット',
                privacy: 'プライバシー',
                registraunaestrella: '星を登録する',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: 'プラネタリウム',
                online: 'オンライン'
            },
            bottom_bar: {
                constellations: '星座',
                constellations_art: '星座のアート',
                atmosphere: '雰囲気',
                landscape: '風景',
                az_grid: '方位角グリッド',
                eq_grid: '赤道儀',
                dso: '深空天體',
                night_mode: 'ナイトモード',
                fullscreen: 'フルスクリーン'
            },
            common: {
                close: '閉じる',
                near: '近 ',
                unknown: '不明'
            },
            date_time_picker: {
                back_realtime: 'リアルタイムに戻る',
                pause_unpause: 'ポーズ/アンポーズ時間',
                daytime: '日中',
                dark_night: '暗い夜',
                moonlight: '月の光',
                sunrise: '日の出',
                sunset: '夕日'
            },
            gui_loader: {
                titlep1: 'プラネタリウムの読み込み ',
                titlep2: 'オンライン',
                titlep3: ' | 星を登録する',
                error_cannot_load_wasm: 'オンラインプラネタリウムが表示されない',
                error_wasm_is_needed: ' お使いのブラウザでは「Web Assembly」を読み込むことができません',
                error_wasm: 'プラネタリウム・オンラインで星空マップを表示するには、Web Assemblyが必要です。別のブラウザで再度お試しください'
            },
            lang_settings_dialog: {
                lang_settings: '言語の変更',
                select_lang: '言語選択'
            },
            location_dialog: {
                use_autolocation: 'オートロケーションの使用'
            },
            location_mgr: {
                my_locations: 'マイロケーション',
                use_this_location: ' この場所を使う',
                unknown_address: '不明なアドレス',
                drag_to_adjust: 'ドラッグで調整'
            },
            planets_visibility: {
                planets_visibility: '惑星の可視性',
                night_from: 'からの夜',
                to: '夜から',
                rise: 'ライズ',
                set: 'セット'
            },
            skysource_search: {
                search: '検索...'
            },
            toolbar: {
                observe: '観察'
            },
            selected_object_info: {
                known_as: 'としても知られています。',
                read_more_on: ' 続きを読む ',
                magnitude: 'マグニチュード',
                distance: '距離',
                radius: '半径',
                spectral_type: 'スペクトルタイプ',
                size: 'サイズ',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'フェーズ',
                not_visible: '今夜は見えません',
                visible: '今夜はいつも見える',
                visibility: '視認性',
                rise: 'ライズ',
                set: 'セット',
                unknown: '不明',
                light_years: '光年',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: '設定を見る',
                milky_way: 'ミルキーウェイ',
                dss: 'DSS',
                simulate_refraction: '屈折のシミュレーション',
                meridian_line: 'メリディアン・ライン',
                ecliptic_line: '黄道線',
                orange_night_mode: 'オレンジ色のナイトモード（デフォルトは赤）'
            }
        }
    },
    de: {
        planets: {
            constellation: 'Konstellation',
            sun: 'Sonne',
            moon: 'Mond',
            moon_other: 'Mond',
            mercury: 'Merkur',
            venus: 'Venus',
            earth: 'Erde',
            mars: 'Mars',
            jupiter: 'Jupiter',
            saturn: 'Saturn',
            uranus: 'Uranus',
            neptune: 'Neptun',
            pluto: 'Pluto',
            planet: 'Planet'
        },
        galaxy_type: {
            elliptical: 'Elliptische Galaxie',
            bar_spiral: 'Balkenspiralgalaxie',
            int_spiral: 'Intermediäre Spiralgalaxie',
            spiral: 'Spiralgalaxie',
            lenticular: 'Linsenförmige Galaxie',
            irregular: 'Irreguläre Galaxie',
            dwf_spheroidal: 'Zwerg-Kugelgalaxie',
            dwf_elliptical: 'Elliptische Zwerggalaxie'
        },
        ui: {
            app: {
                ephemeris: 'Ephemeriden',
                planets_tonight: 'Planeten heute Abend',
                settings: 'Einstellungen',
                lang_settings: 'Sprache ändern',
                view_settings: 'Einstellungen anzeigen',
                about: 'Über',
                data_credits: 'Daten Gutschriften',
                privacy: 'Datenschutz',
                registraunaestrella: 'Einen Stern registrieren',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: 'Planetarium',
                online: 'Online'
            },
            bottom_bar: {
                constellations: 'Konstellationen',
                constellations_art: 'Konstellationen Kunst',
                atmosphere: 'Atmosphäre',
                landscape: 'Landschaft',
                az_grid: 'Azimutales Raster',
                eq_grid: 'Äquatoriales Raster',
                dso: 'Deep-Sky-Objekte',
                night_mode: 'Nacht-Modus',
                fullscreen: 'Vollbildschirm'
            },
            common: {
                close: 'Schließen',
                near: 'Bei ',
                unknown: 'Unbekannt'
            },
            date_time_picker: {
                back_realtime: 'Zurück zu Echtzeit',
                pause_unpause: 'Pause/Unterbrechungszeit',
                daytime: 'Tagsüber',
                dark_night: 'Dunkle Nacht',
                moonlight: 'Mondschein',
                sunrise: 'Sonnenaufgang',
                sunset: 'Sonnenuntergang'
            },
            gui_loader: {
                titlep1: 'Planetarium Online laden ',
                titlep2: '',
                titlep3: ' | Einen Stern registrieren',
                error_cannot_load_wasm: 'Online-Planetarium konnte nicht angezeigt werden',
                error_wasm_is_needed: ' Ihr Browser kann die Web Assembly nicht laden!',
                error_wasm: 'Damit Planetarium Online die Sternenkarte anzeigen kann, ist Web Assembly erforderlich. Versuchen Sie es noch einmal mit einem anderen Browser!'
            },
            lang_settings_dialog: {
                lang_settings: 'Sprache ändern',
                select_lang: 'Sprache auswählen'
            },
            location_dialog: {
                use_autolocation: 'Autolokalisierung verwenden'
            },
            location_mgr: {
                my_locations: 'Meine Standorte',
                use_this_location: ' Verwenden Sie diesen Ort',
                unknown_address: 'Unbekannte Adresse',
                drag_to_adjust: 'Ziehen zum Einstellen'
            },
            planets_visibility: {
                planets_visibility: 'Planeten Sichtbarkeit',
                night_from: 'Nacht von',
                to: 'bis',
                rise: 'Steigen',
                set: 'Setzen'
            },
            skysource_search: {
                search: 'Suche...'
            },
            toolbar: {
                observe: 'Beobachten Sie'
            },
            selected_object_info: {
                known_as: 'Auch bekannt als',
                read_more_on: ' mehr lesen auf ',
                magnitude: 'Größenordnung',
                distance: 'Entfernung',
                radius: 'Radius',
                spectral_type: 'Spektraler Typ',
                size: 'Größe',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'Phase',
                not_visible: 'Heute Nacht nicht sichtbar',
                visible: 'Heute Nacht immer sichtbar',
                visibility: 'Sichtbarkeit',
                rise: 'Steigen',
                set: 'Setzen',
                unknown: 'Unbekannt',
                light_years: 'Lichtjahre',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: 'Einstellungen anzeigen',
                milky_way: 'Milchstraße',
                dss: 'DSS',
                simulate_refraction: 'Brechung simulieren',
                meridian_line: 'Meridian-Linie',
                ecliptic_line: 'Ekliptik-Linie',
                orange_night_mode: 'Orangefarbener Nachtmodus (Standard ist rot)'
            }
        }
    },
    pl: {
        planets: {
            constellation: 'Gwiazdozbiór',
            sun: 'słońce',
            moon: 'księżyc',
            moon_other: 'księżyc',
            mercury: 'merkury',
            venus: 'wenus',
            earth: 'ziemia',
            mars: 'mars',
            jupiter: 'jowisz',
            saturn: 'saturn',
            uranus: 'uran',
            neptune: 'neptun',
            pluto: 'pluton',
            planet: 'planeta'
        },
        galaxy_type: {
            elliptical: 'Galaktyka eliptyczna',
            bar_spiral: 'Galaktyka z poprzeczką',
            int_spiral: 'Pośrednia galaktyka spiralna',
            spiral: 'Galaktyka spiralna',
            lenticular: 'Galaktyka soczewkowata',
            irregular: 'Galaktyka nieregularna',
            dwf_spheroidal: 'Karłowata galaktyka sferoidalna',
            dwf_elliptical: 'Karłowata galaktyka eliptyczna'
        },
        ui: {
            app: {
                ephemeris: 'Efemerydy',
                planets_tonight: 'Widoczność planet tej nocy',
                settings: 'Ustawienia',
                lang_settings: 'Zmień język/Change language',
                view_settings: 'Ustawienia wyświetlania',
                about: 'O programie',
                data_credits: 'Źródła danych',
                privacy: 'Prywatność',
                registraunaestrella: 'Zarejestruj gwiazdę',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: 'Planetarium',
                online: 'Online'
            },
            bottom_bar: {
                constellations: 'Gwiazdozbiory',
                constellations_art: 'Rysunki gwiazdozbiorów',
                atmosphere: 'Atmosfera',
                landscape: 'Krajobraz',
                az_grid: 'Siatka azymutalna',
                eq_grid: 'Siatka równikowa',
                dso: 'Obiekty głębokiego nieba',
                night_mode: 'Tryb nocny',
                fullscreen: 'Pełny ekran'
            },
            common: {
                close: 'Zamknij',
                near: 'W pobliżu ',
                unknown: 'Nieznane'
            },
            date_time_picker: {
                back_realtime: 'Powrót do czasu rzeczywistego',
                pause_unpause: 'Wstrzymaj/wznów czas',
                daytime: 'Dzień',
                dark_night: 'Ciemna noc',
                moonlight: 'Światło księżyca',
                sunrise: 'Wschód słońca',
                sunset: 'Zachód słońca'
            },
            gui_loader: {
                titlep1: 'Ładowanie Planetarium ',
                titlep2: 'Online',
                titlep3: ' | Zarejestruj gwiazdę',
                error_cannot_load_wasm: 'Wygląda na to, że Twoja przeglądarka nie obsługuje Web Assembly!',
                error_wasm_is_needed: 'Web Assembly jest wymagane dla Planetarium Online, aby wyświetlać nocne niebo. Prosimy o aktualizację przeglądarki i o ponowną próbę uruchomienia Planetarium Online.',                error_wasm: 'In order for Planetarium Online to display the star map, Web Assembly is required. Try again with different browser!'
            },
            lang_settings_dialog: {
                lang_settings: 'Zmień język',
                select_lang: 'Wybierz język'
            },
            location_dialog: {
                use_autolocation: 'Korzystaj z automatycznej lokalizacji'
            },
            location_mgr: {
                my_locations: 'Moje lokalizacje',
                use_this_location: ' Korzystaj z tej lokalizacji',
                unknown_address: 'Nieznany adres',
                drag_to_adjust: 'Przeciągnij, żeby dopasować'
            },
            planets_visibility: {
                planets_visibility: 'Widoczność planet',
                night_from: 'Noc z',
                to: 'na',
                rise: 'Wschód',
                set: 'Zachód'
            },
            skysource_search: {
                search: 'Szukaj...'
            },
            toolbar: {
                observe: 'Obserwuj'
            },
            selected_object_info: {
                known_as: 'Również znany jako',
                read_more_on: ' przeczytaj więcej na ',
                magnitude: 'Magnitudo',
                distance: 'Odległość',
                radius: 'Promień',
                spectral_type: 'Typ spektralny',
                size: 'Rozmiar',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'Faza',
                not_visible: 'Niewidoczne tej nocy',
                visible: 'Widoczne całą noc',
                visibility: 'Widoczność',
                rise: 'Wschód',
                set: 'Zachód',
                unknown: 'Nieznane',
                light_years: 'lata świetlne',
                au: 'j.a.'
            },
            view_settings_dialog: {
                view_settings: 'Ustawienia widoku',
                milky_way: 'Droga mleczna',
                dss: 'DSS',
                simulate_refraction: 'Symuluj refrakcję',
                meridian_line: 'Linia południka',
                ecliptic_line: 'Linia ekliptyki',
                orange_night_mode: 'Pomarańczowy tryb nocny (domyślny jest czerwony)'
            }
        }
    },
    fr: {
        planets: {
            constellation: 'Constellation',
            sun: 'soleil',
            moon: 'lune',
            moon_other: 'lune',
            mercury: 'Mercure',
            venus: 'Vénus',
            earth: 'Terre',
            mars: 'Mars',
            jupiter: 'Jupiter',
            saturn: 'Saturne',
            uranus: 'Uranus',
            neptune: 'Neptune',
            pluto: 'Pluton',
            planet: 'planète'
        },
        galaxy_type: {
            elliptical: 'Galaxie elliptique',
            bar_spiral: 'Galaxie spirale barrée',
            int_spiral: 'Galaxie spirale intermédiaire',
            spiral: 'Galaxie spirale',
            lenticular: 'Galaxie lenticulaire',
            irregular: 'Galaxie irrégulière',
            dwf_spheroidal: 'Galaxie naine sphéroïdale',
            dwf_elliptical: 'Galaxie naine elliptique'
        },
        ui: {
            app: {
                ephemeris: 'Éphéméride',
                planets_tonight: 'Les planètes ce soir',
                settings: 'Paramètres',
                lang_settings: 'Changer de langue',
                view_settings: 'Afficher les paramètres',
                about: 'À propos de',
                data_credits: 'Crédits de données',
                privacy: 'Vie privée',
                registraunaestrella: 'Enregistrer une étoile',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: 'Planétarium',
                online: 'Online'
            },
            bottom_bar: {
                constellations: 'Constellations',
                constellations_art: 'Constellations Art',
                atmosphere: 'Atmosphère',
                landscape: 'Paysage',
                az_grid: 'Grille azimutale',
                eq_grid: 'Grille équatoriale',
                dso: 'Objets du ciel profond',
                night_mode: 'Mode nuit',
                fullscreen: 'Plein écran'
            },
            common: {
                close: 'Fermer',
                near: 'Près de ',
                unknown: 'Inconnu'
            },
            date_time_picker: {
                back_realtime: 'Retour au temps réel',
                pause_unpause: 'Temps de pause ou de non-pause',
                daytime: 'En journée',
                dark_night: 'Nuit noire',
                moonlight: 'Clair de lune',
                sunrise: 'Lever du soleil',
                sunset: 'Coucher de soleil'
            },
            gui_loader: {
                titlep1: 'Chargement du Planétarium ',
                titlep2: 'Online',
                titlep3: ' | Enregistrer une étoile',
                error_cannot_load_wasm: 'Le planétarium en ligne n\'a pas pu être affiché',
                error_wasm_is_needed: ' Votre navigateur ne peut pas charger Web Assembly!',
                error_wasm: 'Pour que Planetarium Online puisse afficher la carte des étoiles, un Web Assembly est nécessaire. Essayez à nouveau avec un autre navigateur!'
            },
            lang_settings_dialog: {
                lang_settings: 'Changer de langue',
                select_lang: 'Sélectionner la langue'
            },
            location_dialog: {
                use_autolocation: 'Utiliser l\'autolocalisation'
            },
            location_mgr: {
                my_locations: 'Mes emplacements',
                use_this_location: ' Utilisez cet emplacement',
                unknown_address: 'Adresse inconnue',
                drag_to_adjust: 'Faites glisser pour ajuster'
            },
            planets_visibility: {
                planets_visibility: 'Visibilité des planètes',
                night_from: 'Nuit de',
                to: 'à',
                rise: 'Lever',
                set: 'Coucher'
            },
            skysource_search: {
                search: 'Recherche...'
            },
            toolbar: {
                observe: 'Observer'
            },
            selected_object_info: {
                known_as: 'Également connu sous le nom de',
                read_more_on: ' lire la suite ',
                magnitude: 'Magnitude',
                distance: 'Distance',
                radius: 'Rayon',
                spectral_type: 'Type spectral',
                size: 'Taille',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'Phase',
                not_visible: 'Non visible ce soir',
                visible: 'Toujours visible ce soir',
                visibility: 'Visibilité',
                rise: 'Lever',
                set: 'Coucher',
                unknown: 'Inconnu',
                light_years: 'années-lumière',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: 'Afficher les paramètres',
                milky_way: 'Voie lactée',
                dss: 'DSS',
                simulate_refraction: 'Simuler la réfraction',
                meridian_line: 'Ligne méridienne',
                ecliptic_line: 'Ligne écliptique',
                orange_night_mode: 'Mode nuit orange (rouge par défaut)'
            }
        }
    },
    pt: {
        planets: {
            constellation: 'Constelação',
            sun: 'sol',
            moon: 'lua',
            moon_other: 'satélite',
            mercury: 'Mercúrio',
            venus: 'Vênus',
            earth: 'Terra',
            mars: 'Marte',
            jupiter: 'Júpiter',
            saturn: 'Saturno',
            uranus: 'Urano',
            neptune: 'Netuno',
            pluto: 'Plutão',
            planet: 'planeta'
        },
        galaxy_type: {
            elliptical: 'Galáxia elíptica',
            bar_spiral: 'Galáxia espiral barrada',
            int_spiral: 'Galáxia espiral intermediária',
            spiral: 'Galáxia espiral',
            lenticular: 'Galáxia lenticular',
            irregular: 'Galáxia irregular',
            dwf_spheroidal: 'Galáxia anã esferoidal',
            dwf_elliptical: 'Galáxia anã elíptica'
        },
        ui: {
            app: {
                ephemeris: 'Efemérides',
                planets_tonight: 'Planetas Hoje à noite',
                settings: 'Configurações',
                lang_settings: 'Mudança de idioma',
                view_settings: 'Ver Configurações',
                about: 'Sobre',
                data_credits: 'Créditos de dados',
                privacy: 'Privacidade',
                registraunaestrella: 'Registar uma estrela',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: 'Planetário',
                online: 'Online'
            },
            bottom_bar: {
                constellations: 'Constelações',
                constellations_art: 'Arte das Constelações',
                atmosphere: 'Atmosfera',
                landscape: 'Paisagem',
                az_grid: 'Grade Azimutal',
                eq_grid: 'Rede Equatorial',
                dso: 'Objetos do Céu Profundo',
                night_mode: 'Modo Noturno',
                fullscreen: 'Tela completa'
            },
            common: {
                close: 'Fechar',
                near: 'Perto de ',
                unknown: 'Desconhecido'
            },
            date_time_picker: {
                back_realtime: 'De volta ao tempo real',
                pause_unpause: 'Tempo de pausa/desacusa',
                daytime: 'De dia',
                dark_night: 'Noite escura',
                moonlight: 'Luz da Lua',
                sunrise: 'Nascer do sol',
                sunset: 'Pôr-do-sol'
            },
            gui_loader: {
                titlep1: 'Carregamento do Planetário ',
                titlep2: 'Online',
                titlep3: ' | Registar uma estrela',
                error_cannot_load_wasm: 'Planetário Online não poderia ser exibido',
                error_wasm_is_needed: ' Seu navegador não pode carregar a Web Assembly!',
                error_wasm: 'Para que o Planetarium Online possa exibir o mapa estelar, é necessário o Web Assembly. Tente novamente com um navegador diferente!'
            },
            lang_settings_dialog: {
                lang_settings: 'Mudança de idioma',
                select_lang: 'Selecione o idioma'
            },
            location_dialog: {
                use_autolocation: 'Use a localização automática'
            },
            location_mgr: {
                my_locations: 'Minhas localidades',
                use_this_location: ' Use este local',
                unknown_address: 'Endereço Desconhecido',
                drag_to_adjust: 'Arrastar para ajustar'
            },
            planets_visibility: {
                planets_visibility: 'Visibilidade dos planetas',
                night_from: 'Noite de',
                to: 'a',
                rise: 'Nascer',
                set: 'Pôr'
            },
            skysource_search: {
                search: 'Busca...'
            },
            toolbar: {
                observe: 'Observe'
            },
            selected_object_info: {
                known_as: 'Também conhecido como',
                read_more_on: ' leia mais sobre ',
                magnitude: 'Magnitude',
                distance: 'Distância',
                radius: 'Radius',
                spectral_type: 'Tipo espectral',
                size: 'Tamanho',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'Fase',
                not_visible: 'Não visível hoje à noite',
                visible: 'Sempre visível hoje à noite',
                visibility: 'Visibilidade',
                rise: 'Nascer',
                set: 'Pôr',
                unknown: 'Desconhecido',
                light_years: 'anos-luz',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: 'Ver Configurações',
                milky_way: 'Via Láctea',
                dss: 'DSS',
                simulate_refraction: 'Simular a refração',
                meridian_line: 'Linha Meridiana',
                ecliptic_line: 'Linha Eclíptica',
                orange_night_mode: 'Modo noturno laranja (o padrão é vermelho)'
            }
        }
    },
    ru: {
        planets: {
            constellation: 'Созвездия',
            sun: 'солнце',
            moon: 'луна',
            moon_other: 'спутник',
            mercury: 'Меркурий',
            venus: 'Венера',
            earth: 'Земля',
            mars: 'Марс',
            jupiter: 'Юпитер',
            saturn: 'Сатурн',
            uranus: 'Уран',
            neptune: 'Нептун',
            pluto: 'Плутон',
            planet: 'планета'
        },
        galaxy_type: {
            elliptical: 'Эллиптическая галактика',
            bar_spiral: 'Спиральная галактика с перемычкой',
            int_spiral: 'Спиральная галактика переходного типа',
            spiral: 'Спиральная галактика',
            lenticular: 'Линзовидная галактика',
            irregular: 'Неправильная галактика',
            dwf_spheroidal: 'Карликовая сфероидальная галактика',
            dwf_elliptical: 'Карликовая эллиптическая галактика'
        },
        ui: {
            app: {
                ephemeris: 'Эфемерида',
                planets_tonight: 'Планеты сегодня вечером',
                settings: 'Настройки',
                lang_settings: 'Изменить язык',
                view_settings: 'Просмотр настроек',
                about: 'О сайте',
                data_credits: 'Кредиты данных',
                privacy: 'Конфиденциальность',
                registraunaestrella: 'Зарегистрировать звезду',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: 'Планетарий',
                online: 'Онлайн'
            },
            bottom_bar: {
                constellations: 'Созвездия',
                constellations_art: 'Созвездия Искусство',
                atmosphere: 'Атмосфера',
                landscape: 'Ландшафт',
                az_grid: 'Азимутальная сетка',
                eq_grid: 'Экваториальная сетка',
                dso: 'Объекты глубокого неба',
                night_mode: 'Ночной режим',
                fullscreen: 'Полный экран'
            },
            common: {
                close: 'Закрыть',
                near: 'Около ',
                unknown: 'Неизвестно'
            },
            date_time_picker: {
                back_realtime: 'Вернуться к реальному времени',
                pause_unpause: 'Время паузы/отключения',
                daytime: 'Дневное время',
                dark_night: 'Темная ночь',
                moonlight: 'Лунный свет',
                sunrise: 'Восход солнца',
                sunset: 'Закат солнца'
            },
            gui_loader: {
                titlep1: 'Загрузка Планетарий ',
                titlep2: 'онлайн',
                titlep3: ' | Зарегистрировать звезду',
                error_cannot_load_wasm: 'Онлайн-планетарий не удалось отобразить',
                error_wasm_is_needed: ' Ваш браузер не может загрузить веб-ассемблер!',
                error_wasm: 'Для того чтобы Planetarium Online мог отображать звездную карту, требуется Web Assembly. Попробуйте еще раз с другим браузером!'
            },
            lang_settings_dialog: {
                lang_settings: 'Изменить язык',
                select_lang: 'Выберите язык'
            },
            location_dialog: {
                use_autolocation: 'Используйте автолокацию'
            },
            location_mgr: {
                my_locations: 'Мои места',
                use_this_location: ' Используйте это место',
                unknown_address: 'Неизвестный адрес',
                drag_to_adjust: 'Перетащите для регулировки'
            },
            planets_visibility: {
                planets_visibility: 'Видимость планет',
                night_from: 'Ночь с',
                to: 'на',
                rise: 'Восход',
                set: 'Закат'
            },
            skysource_search: {
                search: 'Поиск...'
            },
            toolbar: {
                observe: 'Смотрите'
            },
            selected_object_info: {
                known_as: 'Также известен как',
                read_more_on: ' читать далее ',
                magnitude: 'Магнитуда',
                distance: 'Расстояние',
                radius: 'Радиус',
                spectral_type: 'Спектральный тип',
                size: 'Размер',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'Фаза',
                not_visible: 'Сегодня не видно',
                visible: 'Всегда видна сегодня',
                visibility: 'Видимость',
                rise: 'Восход',
                set: 'Закат',
                unknown: 'Неизвестно',
                light_years: 'световые годы',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: 'Просмотр настроек',
                milky_way: 'Млечный путь',
                dss: 'DSS',
                simulate_refraction: 'Моделирование преломления',
                meridian_line: 'Меридианная линия',
                ecliptic_line: 'Линия эклиптики',
                orange_night_mode: 'Оранжевый ночной режим (по умолчанию красный)'
            }
        }
    },
    es: {
        planets: {
            constellation: 'Constelación',
            sun: 'sol',
            moon: 'luna',
            moon_other: 'satélite',
            mercury: 'mercurio',
            venus: 'venus',
            earth: 'tierra',
            mars: 'marte',
            jupiter: 'júpiter',
            saturn: 'saturno',
            uranus: 'uranus',
            neptune: 'neptuno',
            pluto: 'plutón',
            planet: 'planeta'
        },
        galaxy_type: {
            elliptical: 'Galaxia elíptica',
            bar_spiral: 'Galaxia espiral barrada',
            int_spiral: 'Galaxia espiral intermedia',
            spiral: 'Galaxia espiral',
            lenticular: 'Galaxia lenticular',
            irregular: 'Galaxia irregular',
            dwf_spheroidal: 'Galaxia enana esferoidal',
            dwf_elliptical: "Galaxia enana elíptica"
        },
        ui: {
            app: {
                ephemeris: 'Efemérides',
                planets_tonight: 'Planetas esta noche',
                settings: 'Ajustes',
                lang_settings: 'Cambiar idioma',
                view_settings: 'Ver configuración',
                about: 'Acerca de',
                data_credits: 'Créditos de datos',
                privacy: 'Privacidad',
                registraunaestrella: 'Registra Una Estrella',
                registraunaestrellalink: 'https://registraunaestrella.com/',
                button_id: 'registra_button',
                planetarium: 'Planetario',
                online: 'Online'
            },
            bottom_bar: {
                constellations: 'Constelaciones',
                constellations_art: 'Arte de Constelaciones',
                atmosphere: 'Atmósfera',
                landscape: 'Paisaje',
                az_grid: 'Proyección Actimutal',
                eq_grid: 'Proyección del Ecuador',
                dso: 'Objetos del espacio profundo',
                night_mode: 'Modo nocturno',
                fullscreen: 'Pantalla completa'
            },
            common: {
                close: 'Cerrar',
                near: 'Cerca ',
                unknown: 'Desconocido',
            },
            date_time_picker: {
                back_realtime: 'Volver al tiempo real',
                pause_unpause: 'Pausar/Reanudar tiempo',
                daytime: 'De día',
                dark_night: 'Noche profunda',
                moonlight: 'Luz de la luna',
                sunrise: 'Amanecer',
                sunset: 'Atardecer'
            },
            gui_loader: {
                titlep1: 'Cargando... Planetario ',
                titlep2: 'Online',
                titlep3: ' | Registra una Estrella',
                error_cannot_load_wasm: 'No se pudo mostrar el Planetario Online',
                error_wasm_is_needed: ' Su navegador no puede cargar Web Assembly!',
                error_wasm: 'Para que el Planetario Online muestre el mapa estelar, es necesario el Web Assembly. Inténtalo de nuevo con otro navegador.'
            },
            lang_settings_dialog: {
                lang_settings: 'Cambiar el idioma',
                select_lang: 'Seleccione el idioma'
            },
            location_dialog: {
                use_autolocation: 'Usar auto Geolocalización'
            },
            location_mgr: {
                my_locations: 'Mis ubicaciones',
                use_this_location: ' Usar esta Ubicación',
                unknown_address: 'Desconocido',
                drag_to_adjust: 'Arrastre para ajustar'
            },
            planets_visibility: {
                planets_visibility: 'Visibilidad de planetas',
                night_from: 'Noche de',
                to: 'a',
                rise: 'Salida',
                set: 'Puesta'
            },
            skysource_search: {
                search: 'Buscar...'
            },
            toolbar: {
                observe: 'Eventos'
            },
            selected_object_info: {
                known_as: 'Also known as',
                read_more_on: ' ver más en ',
                magnitude: 'Magnitud',
                distance: 'Distancia',
                radius: 'Radio',
                spectral_type: 'Tipo espectral',
                size: 'Tamaño',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'Fase',
                not_visible: 'No visible esta noche',
                visible: 'Siempre visible esta noche',
                visibility: 'Visibility',
                rise: 'Ascenso',
                set: 'Descenso',
                unknown: 'Desconocido',
                light_years: 'años luz',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: 'Opciones de vista',
                milky_way: 'Vía láctea',
                dss: 'DSS',
                simulate_refraction: 'Simula la refracción',
                meridian_line: 'Línea meridiana',
                ecliptic_line: 'Linea ecliptica',
                orange_night_mode: 'Orange night mode (default is red)'
            }
        }
    },
    it: {
        planets: {
            constellation: 'Costellazione',
            sun: 'sole',
            moon: 'luna',
            moon_other: 'luna',
            mercury: 'mercurio',
            venus: 'venere',
            earth: 'terra',
            mars: 'marte',
            jupiter: 'giove',
            saturn: 'saturno',
            uranus: 'urano',
            neptune: 'nettuno',
            pluto: 'plutone',
            planet: 'pianeta'
        },
        galaxy_type: {
            elliptical: 'Galassia ellittica',
            bar_spiral: 'Galassia a spirale barrata',
            int_spiral: 'Galassia a spirale intermedia',
            spiral: 'Galassia a spirale',
            lenticular: 'Galassia lenticolare',
            irregular: 'Galassia irregolare',
            dwf_spheroidal: 'Galassia sferoidale nana',
            dwf_elliptical: 'Galassia ellittica nana'
        },
        ui: {
            app: {
                ephemeris: 'Ephemeris',
                planets_tonight: 'Pianeti stanotte',
                settings: 'Impostazioni',
                lang_settings: 'Cambiare la lingua',
                view_settings: 'Visualizza le impostazioni',
                about: 'Informazioni su',
                data_credits: 'Crediti dati',
                privacy: 'Privacy',
                registraunaestrella: 'Registra una stella',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: 'Planetario',
                online: 'Online'
            },
            bottom_bar: {
                constellations: 'Costellazioni',
                constellations_art: 'Costellazioni Arte',
                atmosphere: 'Atmosfera',
                landscape: 'Paesaggio',
                az_grid: 'Griglia Azimutale',
                eq_grid: 'Griglia equatoriale',
                dso: 'Oggetti del cielo profondo',
                night_mode: 'Modalità notte',
                fullscreen: 'Schermo intero'
            },
            common: {
                close: 'Vicino',
                near: 'Vicino a ',
                unknown: 'Sconosciuto'
            },
            date_time_picker: {
                back_realtime: 'Torna al tempo reale',
                pause_unpause: 'Tempo di pausa/pausa',
                daytime: 'Giorno',
                dark_night: 'Notte scura',
                moonlight: 'Luce della luna',
                sunrise: 'Alba',
                sunset: 'Tramonto'
            },
            gui_loader: {
                titlep1: 'Caricamento del Planetario ',
                titlep2: 'Online',
                titlep3: ' | Registra una stella',
                error_cannot_load_wasm: 'Il Planetario Online non può essere visualizzato',
                error_wasm_is_needed: ' Il tuo browser non può caricare Web Assembly!',
                error_wasm: 'Affinché Planetarium Online possa visualizzare la mappa stellare, è necessario Web Assembly. Riprova con un altro browser!'
            },
            lang_settings_dialog: {
                lang_settings: 'Cambia lingua',
                select_lang: 'Seleziona la lingua'
            },
            location_dialog: {
                use_autolocation: 'Usa l\'autolocalizzazione'
            },
            location_mgr: {
                my_locations: 'Le mie posizioni',
                use_this_location: ' Usa questa posizione',
                unknown_address: 'Indirizzo sconosciuto',
                drag_to_adjust: 'Trascinare per regolare'
            },
            planets_visibility: {
                planets_visibility: 'Visibilità dei pianeti',
                night_from: 'Notte da',
                to: 'a',
                rise: 'Sorgere',
                set: 'Imposta'
            },
            skysource_search: {
                search: 'Cerca...'
            },
            toolbar: {
                observe: 'Osservare'
            },
            selected_object_info: {
                known_as: 'Conosciuto anche come',
                read_more_on: ' Leggi di più su ',
                magnitude: 'Magnitudine',
                distance: 'Distanza',
                radius: 'Raggio',
                spectral_type: 'Tipo spettrale',
                size: 'Dimensione',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'Fase',
                not_visible: 'Non visibile stasera',
                visible: 'Sempre visibile stasera',
                visibility: 'Visibilità',
                rise: 'Aumento',
                set: 'Set',
                unknown: 'Sconosciuto',
                light_years: 'anni luce',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: 'Impostazioni di vista',
                milky_way: 'Via Lattea',
                dss: 'DSS',
                simulate_refraction: 'Simulare la rifrazione',
                meridian_line: 'Linea meridiana',
                ecliptic_line: 'Linea eclittica',
                orange_night_mode: 'Modalità notturna arancione (l\'impostazione predefinita è rossa)'
            }
        }
    },
    nl: {
        planets: {
            constellation: 'Sterrenbeeld',
            sun: 'zon',
            moon: 'maan',
            moon_other: 'maan',
            mercury: 'kwik',
            venus: 'venus',
            earth: 'aarde',
            mars: 'mars',
            jupiter: 'jupiter',
            saturn: 'saturnus',
            uranus: 'uranus',
            neptune: 'neptunus',
            pluto: 'pluto',
            planet: 'planeet'
        },
        galaxy_type: {
            elliptical: 'Elliptisch Melkwegstelsel',
            bar_spiral: 'Spiraalstelsel',
            int_spiral: 'Intermediair spiraalstelsel',
            spiral: 'Spiraalstelsel',
            lenticular: 'Lensvormig Stelsel',
            irregular: 'Onregelmatig Stelsel',
            dwf_spheroidal: 'Dwerg Sferoïdaal Stelsel',
            dwf_elliptical: 'Dwerg-Eliptisch Stelsel'
        },
        ui: {
            app: {
                ephemeris: 'Ephemeris',
                planets_tonight: 'Planeten vannacht',
                settings: 'Instellingen',
                lang_settings: 'Verander taal',
                view_settings: 'Instellingen bekijken',
                about: 'Over',
                data_credits: 'Gegevens Kredieten',
                privacy: 'Privacy',
                registraunaestrella: 'Registreer een sterrenbeeld',
                registraunaestrellalink: 'https://register-star.com/',
                button_id: 'register_button',
                planetarium: 'Planetarium',
                online: 'Online'
            },
            bottom_bar: {
                constellations: 'Sterrenbeelden',
                constellations_art: 'Sterrenbeelden Kunst',
                atmosphere: 'Sfeer',
                landscape: 'Landschap',
                az_grid: 'Azimutaal Rooster',
                eq_grid: 'Equatoriaal Rooster',
                dso: 'Diepe hemel objecten',
                night_mode: 'Nachtmodus',
                fullscreen: 'Volledig scherm'
            },
            common: {
                close: 'Dichtbij',
                near: 'Dichtbij ',
                unknown: 'Onbekende'
            },
            date_time_picker: {
                back_realtime: 'Terug naar realtime',
                pause_unpause: 'Pauze/onderbrekingstijd',
                daytime: 'Overdag',
                dark_night: 'Donkere nacht',
                moonlight: 'Maanlicht',
                sunrise: 'Zonsopgang',
                sunset: 'Zonsondergang'
            },
            gui_loader: {
                titlep1: 'Planetarium laden ',
                titlep2: 'Online',
                titlep3: ' | Registreer een sterrenbeeld',
                error_cannot_load_wasm: 'Online Planetarium kon niet worden weergegeven',
                error_wasm_is_needed: ' Uw browser kan Web Assembly niet laden!',
                error_wasm: 'Om Planetarium Online de sterrenkaart te laten weergeven, is Web Assembly nodig. Probeer het opnieuw met een andere browser!'
            },
            lang_settings_dialog: {
                lang_settings: 'Verander van taal',
                select_lang: 'Kies taal'
            },
            location_dialog: {
                use_autolocation: 'Autolocatie gebruiken'
            },
            location_mgr: {
                my_locations: 'Mijn Locaties',
                use_this_location: ' Gebruik deze locatie',
                unknown_address: 'Onbekend adres',
                drag_to_adjust: 'Slepen om aan te passen'
            },
            planets_visibility: {
                planets_visibility: 'Planeten Zichtbaarheid',
                night_from: 'Nacht van',
                to: 'tot',
                rise: 'Opkomst',
                set: 'Stel'
            },
            skysource_search: {
                search: 'Zoek...'
            },
            toolbar: {
                observe: 'Observeer'
            },
            selected_object_info: {
                known_as: 'Ook bekend als',
                read_more_on: ' lees meer op ',
                magnitude: 'Magnitude',
                distance: 'Afstand',
                radius: 'Straal',
                spectral_type: 'Spectral type',
                size: 'Grootte',
                ra_dec: 'Ra/Dec',
                az_alt: 'Az/Alt',
                phase: 'Fase',
                not_visible: 'Vanavond niet zichtbaar',
                visible: 'Altijd zichtbaar vanavond',
                visibility: 'Zichtbaarheid',
                rise: 'Stijging',
                set: 'Set',
                unknown: 'Onbekend',
                light_years: 'lichtjaren',
                au: 'AU'
            },
            view_settings_dialog: {
                view_settings: 'Bekijk Instellingen',
                milky_way: 'Melkweg',
                dss: 'DSS',
                simulate_refraction: 'Breking simuleren',
                meridian_line: 'Meridiaanlijn',
                ecliptic_line: 'Ecliptische lijn',
                orange_night_mode: 'Oranje nachtmodus (standaard is rood)'
            }
        }
    }
}

export default translations

Vue.use(VueI18n)
export const i18n = new VueI18n({locale: language, fallbackLocale: 'en', messages: translations, silentTranslationWarn: false})
document.title = `${i18n.t('ui.app.planetarium')} ${i18n.t('ui.app.online')} | Registra una Estrella`